import { render } from "./HeroiconsSolidStar.vue?vue&type=template&id=7e27d4df"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStar.vue"]])

export default __exports__